<template>
    <POAgent></POAgent>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const POAgent = defineAsyncComponent(() =>
    import("../../components/Purchasing/POAgent/POAgent.vue")
);

export default {
    name: "PO_Agent", //The name you are in should not equal the name of the component you are importing.
    components: { POAgent, AuthLayout },
};
</script>
